// extracted by mini-css-extract-plugin
export default {"container":"Report-module__container__0-QIS","next":"Report-module__next__Fe803","containerWhite":"Report-module__containerWhite__GlLHv","fold":"Report-module__fold__k0sgZ"};